import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	const [{ match }] = useRouter();

	const issueKey = match.params.issueKey ?? '';

	return <ScreenRedirect to={`/issues/${issueKey}`} />;
};
